<template>
  <div>

    <el-dialog title="提示" :visible.sync="show" width="30%" :close-on-click-modal='false' :modal='false'>
      <div>

        <div class="upload">

          <input type="file" v-if="!disable"  @change='getFile($event)' />

          <el-button type='success' :disabled='disable'>上传</el-button>



        </div>

        <div style="margin-top: 20px;" v-if="percent.total">
          <el-progress  style="width: 100%;" :text-inside="true" :stroke-width="26" :percentage="p"></el-progress>
        </div>


      </div>

    </el-dialog>

    <slot>
      <el-button type='success' size='small' @click='show=true'>上传</el-button>
    </slot>

  </div>
</template>

<script>
  export default {
    name: "UploadPlus",
    data() {
      return {

        show: false,
        dir_name: '',
        disable:false,
        percent:{
          total:0,
          current:0
        }

      }
    },
    methods: {

      /**
       * 文件切割
       * @param {Object} file
       * @param {Object} startByte
       * @param {Object} endByte
       */
      blobSlice(file, startByte, endByte) {
        if (file.slice) {
          return file.slice(startByte, endByte);


        } else if (file.webitSlice) {

          return file.webkitSlice(startByte, endByte);

        } else if (file.mozSlice) {

          return file.mozSlice(startByte, endByte);

        } else {


          return null;
        }


      },
      async getFile(e) {



        let size = e.target.files[0].size;



        let total = Math.ceil(size / this.slice_size);

        this.disable=true;

        this.percent.total=total;

        for (let i = 0; i < total; i++) {

          let file = this.blobSlice(e.target.files[0], i * this.slice_size, i * this.slice_size + this.slice_size);

          let form = new FormData();

          form.append('file', file);

          form.append('total', total);

          form.append('current', i + 1);

          form.append('dir_name', this.dir_name);

          form.append('name', e.target.files[0].name);

          let re = await this.upload(form);

          this.percent.current=i+1;


          if (re.code == 2) {

            this.$alert(re.msg, '错误', {
              confirmButtonText: '确定',

            });

            this.disable=false;

            this.resetObj(this.percent)

            break;

          }


          if(re.code==3){

            this.resetObj(this.percent)

            if(this.auto_close) this.show=false;

            this.$emit('success',re.data);

            this.disable=false;
          }



        }

      },
      upload(form) {

        return new Promise((succes, fail) => {

          this.httpPost({
            url: '/admin/upload/uploadForBigFile',
            data: form,
          }).then((re) => {

            // return re;

            this.dir_name = re.data.dir_name;

            succes(re);

          })

        });


      }


    },
    created() {

    },
    computed: {

      /**
       * 计算百分比
       */
      p(){

        if(this.percent.total==0) return 0;

        return Math.ceil(this.percent.current/this.percent.total*100);

      }

    },
    components: {

    },
    props: {

      /**
       * 每个文件切割大小
       */
      slice_size: {

        type: Number,
        default: 3145728

      },
      /**
       * 上传成功后是否自动关闭弹窗
       */
      auto_close:{
        type:Boolean,
        default:false
      }


    }

  }
</script>

<style scoped>
  .upload {
    position: relative;
    width: -webkit-fit-content;

  }

  .upload>input {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;

  }
</style>



// WEBPACK FOOTER //
// src/components/common/UploadPlus.vue